<template>
  <u-modal
    class="delete-dialog"
    :class="!showIcon ? 'no-icon' : ''"
    :visible="modalVisibility"
    :width="width"
    closable
    vertical
    footer-hide
    @close="closeOnCancel ? handleCancel() : handleClose()"
    @after-visible-change="afterClose"
  >
    <template #header>
      <BotIcon v-show="showIcon" name="error" :size="22" :padding="0" />
      <div
        v-if="title"
        class="text-left font-semibold text-lg text-primary leading-[26px]"
        :class="{ 'ml-3': showIcon }"
      >
        {{ title }}
      </div>
    </template>
    <div class="flex items-center common-modal-body">
      <slot name="content">
        <p class="content" :class="{ hasTitle: title }">
          <HighlightText
            v-if="infoText"
            :full-text="infoText"
            :keyword="keyword"
            :key-style="{ color: 'var(--theme-color)' }"
          />
          <slot name="tip" />
        </p>
      </slot>
    </div>
    <div class="btn-wrap">
      <u-button
        class="common-btn"
        @click="handleCancel"
        data-testid="components-deletedialog-cancel-btn"
      >
        {{ cancelText || $t('common.124a48309c32c98c65a3f5c830338f54') }}
      </u-button>
      <u-button
        type="danger"
        class="common-btn"
        :loading="loading"
        @click="handleSure"
        data-testid="components-deletedialog-sure-btn"
      >
        {{ confirmText || $t('common.7e6d4a3e09aab72488bfb6af4ef2bc81') }}
      </u-button>
    </div>
  </u-modal>
</template>

<script>
import { defineComponent } from 'vue';
import { HighlightText } from '@koi-design/vix-components';

export default defineComponent({
  components: {
    HighlightText
  },
  props: {
    width: {
      type: Number,
      default: 400
    },
    infoText: {
      type: String,
      default: ''
    },
    keyword: {
      type: String,
      default: ''
    },
    showIcon: {
      type: Boolean,
      default: true
    },
    modalVisibility: {
      type: Boolean,
      default: false
    },
    loading: {
      type: Boolean,
      default: false
    },
    showFooter: {
      type: Boolean,
      default: true
    },
    title: {
      type: String,
      default: () => {
        return '';
      }
    },
    cancelText: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: ''
    },
    closeOnCancel: {
      type: Boolean,
      default: true
    }
  },
  emits: ['sure', 'cancel', 'after-visible-change', 'close'],
  setup(props, { emit }) {
    const handleCancel = () => {
      emit('cancel');
    };
    const handleSure = () => {
      if (props.loading) {
        return;
      }
      emit('sure');
    };
    const afterClose = val => {
      if (!val) {
        emit('after-visible-change');
      }
    };
    const handleClose = () => {
      emit('close');
    };
    return {
      handleCancel,
      handleSure,
      afterClose,
      handleClose
    };
  }
});
</script>

<style scoped lang="less">
.btn-wrap {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
  word-break: break-all;
  width: 100%;
  gap: 8px;
  --button-padding-base: 12px;
  --button-height-base: 32px;
}
.modal-header {
  font-weight: bold;
  color: var(--title-color);
  height: 24px;
  line-height: 24px;
  font-size: 18px;
}
.content {
  // width: 350px;
  color: var(--font-color);
  line-height: 22px;
  word-break: break-word;
  white-space: pre-wrap;
  &.hasTitle {
    margin-top: 0;
  }
}
</style>

<style lang="less">
.delete-dialog {
  .uui-modal {
    padding: 20px 24px;
  }
  .uui-modal-close {
    top: 20px;
    right: 24px;
  }
  .uui-modal-header {
    height: 24px;
    line-height: 24px;
    padding: 0;
  }
  .uui-modal-body {
    padding: 8px 0 20px 34px;
  }

  &.no-icon {
    .uui-modal-body {
      padding-left: 0;
    }
  }
}
</style>
